import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=4e056a9a&scoped=true&"
import script from "./Ecommerce.vue?vue&type=script&lang=js&"
export * from "./Ecommerce.vue?vue&type=script&lang=js&"
import style0 from "./Ecommerce.vue?vue&type=style&index=0&id=4e056a9a&prod&lang=css&"
import style1 from "./Ecommerce.vue?vue&type=style&index=1&id=4e056a9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e056a9a",
  null
  
)

export default component.exports